import React, { useState, useRef } from "react";
import MessageSummary from "./MessageSummary";
import { useEffect } from "react";
import { useJobProvider } from "../../../../Providers/Client/Jobs";
import moment from "moment";
import { useTimesheetProvider } from "../../../../Providers/Client/Timesheet";
import Daywise from "./DashboardCards/Timesheet/Daywise";
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../../Utils/avatar";
import Back from "../../../../Components/Back";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useCountryStateCityProvider } from "../../../../Providers/Common/CountyStateCity";
import { useSelector } from "react-redux";
import { userPermissions } from "../../../../Utils/constants";

export default function OngoingJobInformation({ reset }) {
  const [job, setJob] = useState({});
  const [showTimesheetDetails, setShowTimesheetDetails] = useState(false);
  const { fetchJobDetails } = useJobProvider();
  const navigate = useNavigate();
  const { selectedTimesheet } = useTimesheetProvider();
  const [isExpanded, setIsExpanded] = useState(false);
  const permissions = useSelector((state) => state.user.permissions);
  const { getCountries, getStatesByCountry, state, country } =
    useCountryStateCityProvider();

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const location = useLocation();
  const from = location.state?.from?.pathname;

  const { id } = useParams();

  useEffect(() => {
    fetchJobDetails(id).then(setJob);

    const words = job?.description?.split(" ");
    const displayText = isExpanded
      ? words?.join(" ")
      : words?.slice(0, 40)?.join(" ");
  }, []);

  useEffect(() => {
    getCountries(job?.country);
    getStatesByCountry(job?.country, job?.state);
  }, [job?.country, job?.state]);

  return !showTimesheetDetails &&
    (selectedTimesheet === null || job.id === id) ? (
    <div>
      <div className="flex flex-col bg-white rounded-lg font-[Roboto] p-4 space-y-3">
        <Back
          onClick={() => {
            navigate(from ? from : "/dashboard/jobscard");
          }}
        />
        <span className="flex flex-row text-gray-700">
          <span className="mr-2 font-medium">Title:</span>
          <span className="ml-[80px]">{job?.name}</span>
        </span>
        <span className="flex flex-row text-gray-700">
          <span className="mr-[40px] font-medium">Description:</span>
          <div className="flex flex-col space-y-1">
            <div className="text-justify">
              {isExpanded
                ? job?.description?.split(" ")?.join(" ")
                : job?.description?.split(" ")?.slice(0, 70)?.join(" ")}
            </div>
            {job?.description?.split(" ").length >= 70 && (
              <div className="flex flex-row justify-start">
                <button
                  type="button"
                  className="text-blue-400"
                  onClick={toggleExpand}
                >
                  {isExpanded ? "See Less" : "See More"}
                </button>
              </div>
            )}
          </div>
        </span>
        <span className="flex flex-row text-gray-700">
          <span className="mr-[85px] font-medium">Skills:</span>
          <span className="space-x-3">
            {job?.main_skill?.map((skill) => {
              return (
                <span className="text-justify text-sm py-0.5 px-1 text-[#139588] w-[83px] h-[25px] border-[1px] border-[#139588]">
                  {skill}
                </span>
              );
            })}
            {!job?.main_skill && "No Skills Provided"}
          </span>
        </span>
        <span className="flex justify-between text-gray-700">
          <span className="font-medium">
            Location:{" "}
            <span className="font-normal ml-[55px]">{job?.location}</span>
          </span>
          <span className="font-medium">
            Start Date:{" "}
            <span className="font-normal">
              {job?.start_date
                ? moment.utc(job.start_date, "YYYY-MM-DD").format("DD/MM/YYYY")
                : null}
            </span>
          </span>
          <span />
        </span>
        {(Object.keys(job).length === 0 && job.constructor === Object) ||
        job?.location === "REMOTE" ? (
          <></>
        ) : (
          <div className="mr-4 flex flex-row justify-between">
            <span className="font-medium">
              Country:{" "}
              <span className="font-normal ml-16">
                {Object.keys(country).length === 0 &&
                country.constructor === Object
                  ? "No Country Provided"
                  : country}
              </span>
            </span>
            <span className="font-medium">
              State:{" "}
              <span className="font-normal ml-2">
                {Object.keys(state).length === 0 && state.constructor === Object
                  ? "No State Provided"
                  : state}
              </span>
            </span>
            <span className="font-medium">
              City:{" "}
              <span className="font-normal ml-2">
                {job?.city || "No City Provided"}
              </span>
            </span>
          </div>
        )}
        <div className="flex justify-between py-2">
          <div className="flex items-center">
            <span className="w-28 mr-4 font-medium">Consultant:</span>
            <div
              className={`flex flex-row py-2 mr-4 text-white w-[250px] rounded-[10px] px-4 items-center gap-x-3 bg-[#2EBAA3] `}
            >
              {job?.consultant?.firstName ? (
                <>
                  <Avatar
                    style={{
                      width: "30px",
                      height: "30px",
                      marginRight: "20px",
                    }}
                    onClick={() =>
                      window.open(
                        `${window.location.origin}/consultant/profile/` +
                          job?.consultant?.id
                      )
                    }
                    className="cursor-pointer"
                    {...stringAvatar(
                      `${job?.consultant?.firstName ?? ""} ${
                        job?.consultant?.lastName ?? ""
                      }`
                    )}
                    src={job?.consultant?.profilePhoto}
                  />
                  <span>
                    {job?.consultant?.firstName} {job?.consultant?.lastName}
                  </span>
                </>
              ) : (
                <span className="flex items-center justify-center">
                  No Consultant Assigned Yet
                </span>
              )}
            </div>
          </div>
          <div className="flex items-center">
            <span className="w-28 mr-4 font-medium">Vendor:</span>
            <div
              className={`flex flex-row py-2 mr-4 text-black w-[250px] rounded-[10px] px-4 items-center gap-x-3 bg-[#CFCFCF] `}
            >
              {job?.child?.firstName ? (
                <>
                  <Avatar
                    style={{
                      width: "30px",
                      height: "30px",
                      marginRight: "20px",
                    }}
                    onClick={() =>
                      window.open(
                        `${window.location.origin}/vendor/profile/` +
                          job?.child?.id
                      )
                    }
                    className="cursor-pointer"
                    {...stringAvatar(`${job?.child?.company ?? ""}`)}
                    src={job?.child?.profilePhoto}
                  />
                  <span>{job?.child?.company}</span>
                </>
              ) : (
                <span className="flex items-center justify-center">
                  No Vendor Assigned Yet
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        {permissions?.includes(`admin-client`) ||
        permissions?.includes(userPermissions.job.timesheetAction) ? (
          <MessageSummary
            consultant={job?.consultant}
            child={job?.child}
            parent={job?.owner}
            id={id}
            setShowTimesheetDetails={setShowTimesheetDetails}
          />
        ) : null}
      </div>
    </div>
  ) : (
    <Daywise
      showDatePicker
      setShowTimesheetDetails={setShowTimesheetDetails}
      job={{ id: id, startDate: job?.start_date }}
    />
  );
}
